import Model from "./Model";
import ContentModel from "./ContentModel";

export default class AssertionModel extends Model {
  id: number;
  userId: number;
  questionId: number;
  position: number;
  correct: boolean;

  static __typename: string = "Assertion";

  constructor(assertion: any, getters: any) {
    super(getters);
    this.id = assertion.id;
    this.userId = assertion.userId;
    this.questionId = assertion.questionByQuestionId || assertion.questionId;
    this.position = assertion.position;
    this.correct = assertion.correct;
  }

  char(): string {
    return "abcdefghijklmnopqrstuvwxyz"[this.position];
  }

  contents(): ContentModel[] {
    return this.getters
      .contentsByAssertionId(this.id)
      .concat()
      .sort((A: ContentModel, B: ContentModel) => A.position - B.position);
  }

  question() {
    return this.getters.questionById(this.questionId);
  }

  legacyContent() {
    return this.contents().map((contentComponent: ContentModel) => {
      var content, url, size, origin, description;
      let behavior = contentComponent.behavior();
      switch (behavior) {
        case "text":
          content = contentComponent.text().body;
          break;
        case "video":
          content = contentComponent.video().providerId;
          break;
        case "image":
          let image = contentComponent.image();
          content = "";
          url = image.url;
          size = image.resizeFactor;
          origin = image.source ? image.source.origin : null;
          description = image.description;
          break;
      }
      return {
        behavior,
        content,
        url,
        size,
        origin,
        description
      };
    });
  }

  raw() {
    return {
      id: this.id,
      userId: this.userId,
      questionId: this.questionId,
      position: this.position,
      correct: this.correct,
      __typename: AssertionModel.__typename
    }
  }

}